import { getRoleName } from 'app/graphql/roleNames'
import { useUserStore } from 'app/stores/StoreContext'
import { taskAssigneeValue } from 'lib/taskAssignee'

export type TaskOwner = { id: string; name: string }

/**
 * Resolve a task assignee (a user `ownerId` or a role `roleId`) into the `{ id, name }` an owner
 * picker shows. Roles come back as `role:<roleId>`, the value the pickers hand around. Users are
 * read through UserStore, the owner of the User entity. Resolves `undefined` when the user is
 * not found.
 */
export function useResolveTaskOwner() {
  const userStore = useUserStore()
  return async (assignee: { ownerId?: string | null; roleId?: string | null }): Promise<TaskOwner | undefined> => {
    if (assignee.roleId) {
      const value = taskAssigneeValue(assignee)!
      return { id: value, name: await getRoleName(assignee.roleId) }
    }
    if (!assignee.ownerId) return undefined
    const result = await userStore.fetchOne(assignee.ownerId)
    const data = result.data as any
    const user = data?.user ?? data
    return user?.id ? { id: user.id, name: user.name } : undefined
  }
}
